import React from 'react';
import {
  Filter,
  List,
  Datagrid,
  TextField,
  EditButton,
  DateField,
  ReferenceInput,
  ReferenceField,
  SelectInput,
  Responsive,
  SimpleList,
  DateInput
} from "react-admin";

import { IngresoTercerosEditComponent } from "../components/IngresoTerceros/IngresoTercerosEditComponent";
import { IngresoTercerosCreateComponent } from "../components/IngresoTerceros/IngresoTercerosCreateComponent";


export const IngresoTercerosFilter = props => {
  return (
    <Filter {...props}>
      <DateInput label="Fecha" source="fecha" />
      <ReferenceInput reference="entidades" source="entidad">
        <SelectInput  optionText="nombre" optionValue="_id" />
      </ReferenceInput>
      <ReferenceInput reference="operarios" source="operario">
        <SelectInput  optionText="nombre" optionValue="_id" />
      </ReferenceInput>
      <ReferenceInput reference="predios" source="predio">
        <SelectInput  optionText="nombre" optionValue="_id" />
      </ReferenceInput>
    </Filter>
  )
}

export const IngresoTercerosList = props => (
  <List {...props} bulkActions={false} filters={<IngresoTercerosFilter />} exporter={false}>
    <Responsive
      small={
        <SimpleList
          primaryText={record => record.pesadorNombre }
          secondaryText={record => new Date(record.fecha).toLocaleDateString() }
        />
      }
      medium={
        <Datagrid>
          <DateField source="fecha" />
          <ReferenceField label="entidad" reference="entidades" source="entidad">
            <TextField source="nombre" />
          </ReferenceField>
          <TextField source="patente" />
          <TextField source="pesadorNombre" />
          <EditButton />
        </Datagrid>
      }
    />
  </List>
);

export const IngresoTercerosCreate = props => (
  <IngresoTercerosCreateComponent {...props} />
);

export const IngresoTercerosEdit = props => (
    <IngresoTercerosEditComponent {...props} />
);



// WEBPACK FOOTER //
// ./src/services/ingresoTerceros.js